import React from "react";
import { Spinner } from "@material-tailwind/react";

export default function LoadingScreen({ text = "جارٍ التحميل..." }) {
  return (
    <div className="flex min-h-[260px] items-center justify-center">
      <div className="glass-card flex items-center gap-3 px-6 py-5 text-brand-800">
        <Spinner className="h-5 w-5" />
        <span className="font-bold">{text}</span>
      </div>
    </div>
  );
}
